import { render, staticRenderFns } from "./tableBestArticles.vue?vue&type=template&id=40c45b17&"
import script from "./tableBestArticles.vue?vue&type=script&lang=js&"
export * from "./tableBestArticles.vue?vue&type=script&lang=js&"
import style0 from "./tableBestArticles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports